<script>
import formatAmount from '@/utils/format-currency'
export default {
  props: {
    comment: {
      type: Object,
      required: true,
    },
  },

  data: () => ({
    settings: { locale: 'en-US', currency: 'USD' },
  }),

  computed: {
    pb() {
      return JSON.parse(this.comment.commentText)
    },
  },

  methods: {
    formatAmount,
    penaltyRenderer({ PenaltyHours, PenaltyType, PenaltyHoursUnitRate }) {
      const penaltyAmountData = `${this.formatAmount(
        PenaltyHoursUnitRate,
        this.settings
      )} x ${PenaltyHours}`
      switch (PenaltyType) {
        case 0:
          return `Missed Rest Break Penalty: ${penaltyAmountData}`
        case 1:
          return `Missed Meal Break Penalty: ${penaltyAmountData}`
        default:
          return ''
      }
    },
  },
}
</script>

<template>
  <div>
    <p>Gross amount: {{ formatAmount(pb.GrossAmount, settings) }}</p>
    <p>Regular rate of pay: {{ formatAmount(pb.RROP, settings) }}</p>
    <p>
      Regular hours: {{ formatAmount(pb.RegularHoursUnitRate, settings) }} x
      {{ pb.RegularHours }}
    </p>
    <p v-if="pb.OvertimeHours > 0">
      Overtime: {{ formatAmount(pb.OvertimeHoursUnitRate, settings) }} x
      {{ pb.OvertimeHours }}
    </p>
    <p v-if="pb.DoubleTimeHours > 0">
      Double Time: {{ formatAmount(pb.DoubleTimeHoursUnitRate, settings) }} x
      {{ pb.DoubleTimeHours }}
    </p>
    <div v-if="pb.TotalPenaltyHours > 0 && pb.Penalties">
      <p v-for="(penalty, index) in pb.Penalties" :key="index">
        {{ penaltyRenderer(penalty) }}
      </p>
    </div>
  </div>
</template>
